if (!customElements.get('product-banner-slider')) {
  class ProductBannerSlider extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        navNextDesktop: '[nav-next]',
        navPrevDesktop: '[nav-prev]',
        navPrevMobile: '[nav-prev-mobile]',
        navNextMobile: '[nav-next-mobile]',
        slider: '[prod-slider]'
      };
      this.initSlider();
    }

    initSlider() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const swiper = new Swiper(this.querySelector(this.selectors.slider), {
        slidesPerView: 1,
        touchRatio: 1,
        speed: 800,
        loop: false,
        spaceBetween: 20,
        shortSwipes: true,
        allowTouchMove: true,
        simulateTouch: true,
        keyboard: {
          enabled: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: isMobile ? this.querySelector(this.selectors.navNextMobile) : this.querySelector(this.selectors.navNextDesktop),
          prevEl: isMobile ? this.querySelector(this.selectors.navPrevMobile) : this.querySelector(this.selectors.navPrevDesktop),
        },
      });
    }
  }

  customElements.define('product-banner-slider', ProductBannerSlider);
}